import { WalkI } from './../../interfaces/Walk';
import { OPEN_PREVIEW,  CLOSE_PREVIEW } from '../constants/index';
import { PreviewState, PreviewActions } from '../types/previewTypes'

const initialState: PreviewState = {
  isOpen: false,
  walk: {} as WalkI
}

const previewReducer = (state = initialState, action: PreviewActions) => {
  const payload = action.payload
  switch(action.type){

    case OPEN_PREVIEW:
      return {
        ...state,
        isOpen: !state.isOpen,
        walk: payload
      }
    
    case CLOSE_PREVIEW:
      return {
        ...state,
        isOpen: false,
        walk: {} as WalkI
      }
    
    default: 
      return state
  }
}

export default previewReducer;